<template>
  <div class="ftpmanager">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">FTP管理</a></li>

          <!-- <li class="fr"><a href="#">离线硬盘管理</a></li> -->
        </ul>
      </nav>
    </div>
    <p class="newftp">
      <a href="javascript:;" @click="addnewftp()">添加新FTP</a>
    </p>
    <el-table :data="tableData" stripe style="width: 100%" class="messagelist">
      <el-table-column prop="url" label="FTP地址" align="center" width="240">
      </el-table-column>
      <el-table-column prop="port" label="端口号" align="center" width="70">
      </el-table-column>
      <el-table-column prop="account" label="账号" align="center" width="180">
      </el-table-column>
      <el-table-column prop="password" label="密码" align="center" width="280">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <a href="javascript:;" @click="addnewftp(scope.row)" class="lookfor">编辑</a>
        </template>
      </el-table-column>
    </el-table>
    <p class="msg">
      FTP地址每<span>1</span>单对应<span>1</span>个FTP地址，如果企业存在<span>多个FTP</span>,
      企业通过该订单的FTP下载数据自行进行其他FTP部署！
    </p>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :append-to-body='true' custom-class="ftpmanagerdialog">
      <ftpItem :model="item" @ftpList="ftpList" :dialogFormVisible="dialogFormVisible" @onDialogVisible="onDialogVisible"></ftpItem>
    </el-dialog>
  </div>
</template>
<script>
import ftpItem from '@/page/usercenter/ftpItem.vue'
export default {
  name: 'ftpmanager',
  components: {
    'ftpItem': ftpItem
  },
  created() {
    this.ftpList()
  },
  data() {
    return {
      dialogFormVisible: false,
      title: 'FTP添加',
      item: {
        id: '',
        url: '',
        account: '',
        password: '',
        port: ''
      },
      tableData: []
    }
  },
  methods: {
    ftpList() {
      this.sapost('/dmc/ftp/ftpList', '', r => {
        this.tableData = r.data
      })
    },
    addnewftp(p) {
      if (p) {
        this.title = 'FTP编辑'
        this.item = {
          id: p.id,
          url: p.url,
          account: p.account,
          password: p.password,
          port: p.port
        }
      } else {
        this.title = 'FTP添加'
      }
      this.dialogFormVisible = true
    },
    onDialogVisible(val) {
      this.dialogFormVisible = val
    }
  }
}
</script>

<style lang="less">
.ftpmanagerdialog {
  .el-dialog__header {
    background: #fff;
    border-radius: 8px 8px 0 0;
    height: 1.25rem;
    .el-dialog__title {
      line-height: 24px;
      font-weight: 500;
      font-size: 14px;
      color: #303133;
    }
  }
}
.ftpmanager {
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav {
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 15px;
        height: 60px;
        color: #b4b8bb;
        li {
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a {
            color: #b4b8bb;
          }
        }
        li.active,
        li:hover {
          border-bottom: 2px solid #f01400;
          a {
            color: #f01400;
          }
        }
        li.fr {
          margin-left: 30px;
        }
      }
    }
  }
  .newftp {
    text-align: right;
    line-height: 36px;
    padding: 10px 0px 20px;
    a {
      display: inline-block;
      padding: 5px 12px;
      border-radius: 15px;
      color: #fff;
      background-color: #f14242;
      font-size: 12px;
      line-height: 18px;
      margin-right: 10px;
    }
  }
  .msg {
    font-size: 14px;
    padding: 18px 10px;
    span {
      color: red;
    }
  }
  .r-title {
    float: right;
    height: 60px;
    line-height: 60px;
    span {
      color: #f01400;
    }
  }
  .pages {
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table__body tr:hover > td {
      background-color: #fef3f3;
    }
    .lookfor {
      background-color: #67c23a;
      color: #fff;
      padding: 3px 20px;
      border-radius: 4px;
      display: inline-block;
    }
    .cell {
      color: #333;
      i {
        font-size: 24px;
        margin-right: 5px;
        color: #ffb805;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/ftpmanager.vue